import { render, staticRenderFns } from "./l-acte.html?vue&type=template&id=87757f38&scoped=true&external"
import script from "./l-acte.js?vue&type=script&lang=js&external"
export * from "./l-acte.js?vue&type=script&lang=js&external"
import style0 from "./l-acte.scss?vue&type=style&index=0&id=87757f38&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87757f38",
  null
  
)

export default component.exports